export default "__VITE_ASSET__DblBGC2U__"